/// <reference path="../../../../typings/globals/jquery/index.d.ts" />
/**
 * Obsługa koszyka
 *
 * @export
 * @class Cart
 * @extends {SimpleCart}
 */
import { SimpleCart } from "./SimpleCart.class";
import { Inputs } from "../forms/Inputs.class";

export class Cart extends SimpleCart {
	constructor() {
		super();
		this.step = 0;
	}
	// ****************************************************************************************************
	// Inicjalizacja Koszyka
	// ****************************************************************************************************
	init() {
		this.step = Number($('#cart').data('sort'));
		this.initQuantityControlers();
		this.initRemoveItemFromCart();
		this.initAddItemToClipboard();
	}
	// ****************************************************************************************************
	// Inicjalizacja kontrolerów ilości w koszyku
	// ****************************************************************************************************
	initQuantityControlers() {
		var that = this;
		if ($('.quantityControler').length > 0) {
			$('.quantityControler').each(function (i, e) {
				var pkoId = $(this).data('pko-id');
				var incBtn = $(this).find('.increaseQuantityBtn');
				var decBtn = $(this).find('.decreaseQuantityBtn');
				var okBtn = $(this).find('.saveQuantityBtn');
				var input = $(this).find('.quantityInput');
				var step = Number(input.data('precision'));
				var limitQuantity = Number(input.data('limit-quantity'));
				var limitMsgType = input.data('msg-type');
				var inputs_kup = $('.quantityInput' + pkoId + '[name=marker_ilosc_kup]');
				var inputs_zam = $('.quantityInput' + pkoId + '[name=marker_ilosc_zam]');
				var unavailableMode = inputs_zam.length > 0;
				var aForm = new Object;
				aForm.obj = $('#cartItemForm' + pkoId);
				aForm.ilosc = aForm.obj.find('input[name=ilosc]');
				aForm.ilosc_kup = aForm.obj.find('input[name=ilosc_kup]');
				aForm.ilosc_zam = aForm.obj.find('input[name=ilosc_zam]');
				aForm.ilosc_max = aForm.obj.find('input[name=ilosc_max]');
				var inputObj = new Inputs();
				inputObj.initQuantityInput(input);
				incBtn.on('click', function () {
					if ( limitQuantity && limitQuantity <= Number(inputs_kup.val()) ) {
						if ( limitMsgType == "outlet" ) {
							//toolsObj.showModalAlert(TXT_OUTLET_MSG_LIMIT_REACHED, TXT_OUTLET_NAME);
							var outletMsg = TXT_OUTLET_MSG_PRODUCT_LIMIT_REACHED;
							toolsObj.showModalAlert(outletMsg.replace("<b>__product__</b><br><br>", "").replace("__before__", Number(input.val())).replace("__after__", limitQuantity), TXT_OUTLET_NAME); // wersja z ilościami
						} else if ( limitMsgType == "gift" ) {
							toolsObj.showModalAlert(CART_MSG_LIMIT_REACHED, CART_MSG_LIMIT_REACHED_TITLE);
						} else {
							toolsObj.showModalAlert(TXT_SOLDOUT_MSG_LIMIT_REACHED);
						}

						incBtn.attr('disabled','disabled');
						return false;
					}

					that.quantityControlerValueChange(input, inputs_kup, inputs_zam, aForm, unavailableMode, step);
				});
				decBtn.on('click', function () {
					if ( limitQuantity )
						incBtn.removeAttr('disabled');
					that.quantityControlerValueChange(input, inputs_kup, inputs_zam, aForm, unavailableMode, -step);
				});
				input.data('lastValue', input.val()).on('change', function () {
					that.quantityControlerValueChange(input, inputs_kup, inputs_zam, aForm, unavailableMode, 0);
				}).on('keydown', function (event) {
					if (event.keyCode == 13) {
						$(this).trigger('change');
						okBtn.trigger('click');
					}
				});
				okBtn.on('click', function () {
					if ( limitQuantity && limitQuantity < Number(inputs_kup.val()) ) {
						if ( limitMsgType == "outlet" ) {
							//toolsObj.showModalAlert(TXT_OUTLET_MSG_LIMIT_REACHED, TXT_OUTLET_NAME);
							var outletMsg = TXT_OUTLET_MSG_PRODUCT_LIMIT_REACHED;
							toolsObj.showModalAlert(outletMsg.replace("<b>__product__</b><br><br>", "").replace("__before__", Number(input.val())).replace("__after__", limitQuantity), TXT_OUTLET_NAME); // wersja z ilościami
						} else if ( limitMsgType == "gift" ) {
							toolsObj.showModalAlert(CART_MSG_LIMIT_REACHED, CART_MSG_LIMIT_REACHED_TITLE);
						} else {
							toolsObj.showModalAlert(TXT_SOLDOUT_MSG_LIMIT_REACHED);
						}

						incBtn.attr('disabled','disabled');
						inputs_kup.val(CART_LIMIT_AMOUNT);
						return false;
					} else if ( limitQuantity && limitQuantity == Number(inputs_kup.val()) )
					{
						return false;
					} else {
						koszyk_przelicz();
					}
				});
			});
		}
	}
	// ****************************************************************************************************
	// Obsługa kliniecia przycisków zmiany ilosci w kontrolerach
	// ****************************************************************************************************
	quantityControlerValueChange(input, inputs_kup, inputs_zam, aForm, unavailableMode, change) {
		var q;
		if (unavailableMode) {
			var maxQ = Number(aForm.ilosc_max.val());
			var kupQ = Number(aForm.ilosc_kup.val());
			var zamQ = Number(aForm.ilosc_zam.val());
			var zamInput = input.attr('name') == 'marker_ilosc_zam';
			q = kupQ + zamQ + change;
			if (q < 0)
				q = 0;
			if (change == 0) {
				change = Number(input.val()) - q;
				q = Number(input.val());
				if (zamInput)
					q = q + Number(aForm.ilosc_kup.first().val());
			}
			if (q > maxQ) {
				aForm.ilosc.val(q);
				aForm.ilosc_kup.val(maxQ);
				aForm.ilosc_zam.val(q - maxQ);
				inputs_kup.val(maxQ);
				inputs_zam.val(q - maxQ);
			}
			else {
				aForm.ilosc.val(q);
				aForm.ilosc_kup.val(q);
				aForm.ilosc_zam.val(0);
				inputs_kup.val(q);
				inputs_zam.val(0);
			}
		}
		else {
			q = Number(input.val()) + change;
			if (q < 0)
				q = 0;
			inputs_kup.val(q);
			aForm.ilosc.val(q);
			aForm.ilosc_kup.val(q);
			aForm.ilosc_zam.val(0);
		}
	}
	// ****************************************************************************************************
	// Obsługa przycisku usuwania pozycji z koszyka
	// ****************************************************************************************************
	initRemoveItemFromCart() {
		var that = this;
		$('.removeItemFromCart').each(function (i, e) {
			var pkoId = $(this).data('pko-id');
			var aForm = new Object;
			aForm.obj = $('#cartItemForm' + pkoId);
			aForm.ilosc = aForm.obj.find('input[name=ilosc]');
			aForm.ilosc_kup = aForm.obj.find('input[name=ilosc_kup]');
			aForm.ilosc_zam = aForm.obj.find('input[name=ilosc_zam]');
			$(this).on('click', function () {
				aForm.ilosc.val(0);
				aForm.ilosc_kup.val(0);
				aForm.ilosc_zam.val(0);
				koszyk_przelicz();
			});
		});

		$('.removeItemFromCartXplus1').each(function (i, e) {
			var pkoIdS = $(this).data('pko-id-s');
			var pkoIdP = $(this).data('pko-id-p');

			if ( pkoIdS ) {
				var aFormS = new Object;
				aFormS.obj = $('#cartItemForm' + pkoIdS);
				aFormS.ilosc = aFormS.obj.find('input[name=ilosc]');
				aFormS.ilosc_kup = aFormS.obj.find('input[name=ilosc_kup]');
				aFormS.ilosc_zam = aFormS.obj.find('input[name=ilosc_zam]');
			}
			if ( pkoIdP ) {
				var aFormP = new Object;
				aFormP.obj = $('#cartItemForm' + pkoIdP);
				aFormP.ilosc = aFormP.obj.find('input[name=ilosc]');
				aFormP.ilosc_kup = aFormP.obj.find('input[name=ilosc_kup]');
				aFormP.ilosc_zam = aFormP.obj.find('input[name=ilosc_zam]');
			}

			$(this).on('click', function () {
				if ( pkoIdP ) {
					aFormP.ilosc.val(0);
					aFormP.ilosc_kup.val(0);
					aFormP.ilosc_zam.val(0);
				}
				if ( pkoIdS ) {
					aFormS.ilosc.val(0);
					aFormS.ilosc_kup.val(0);
					aFormS.ilosc_zam.val(0);
				}
				koszyk_przelicz();
			});
		});
	}
	// ****************************************************************************************************
	// Obsługa przycisku dodawania pozycji do schowka
	// ****************************************************************************************************
	initAddItemToClipboard() {
		var that = this;
		$('.addItemToClipboard').each(function (i, e) {
			var pkoId = $(this).data('pko-id');
			var mode = $(this).data('mode') ? $(this).data('mode') : 'toggle';
			$(this).on('click', function () {
				if (!LOGGED) { // !LOGGED
					toolsObj.showModalAlert('<p class="m-0">' + TXT_CLIPBOARD_UNAVAILABLE + '</p>');
					return false;
				}
				var target = $(this);
				var pageUrl = '/cart?akcja=koszykSkopiujDoSchowka&id' + pkoId + '=1';
				if (!$(this).hasClass('sending')) {
					$.ajax({
						url: pageUrl,
						method: 'POST',
						beforeSend: function () {
							$(target).addClass('sending');
							$('<span id="clipboardSpinner' + pkoId + '" class="clipboardSpinner"><span class="spinner-border spinner-border-sm" role="status"><span class="sr-only">Loading...</span></span></span>').appendTo(target);
						},
						success: function (data) {
							$('#clipboardSpinner' + pkoId).remove();
						},
						complete: function () {
							$(target).removeClass('sending').fadeOut(EFFECTS_SPEED).remove();
						}
					});
				}
				return false;
			});
		});
	}
}